class ImageResource {
  // Best-effort cache warming. A failed image resolves rather than rejects, so a broken
  // URL (404 / CORS / offline) never becomes an unhandled promise rejection — callers
  // (e.g. InitialLoadingManager.saveDataRedux) only await this to warm the cache before
  // rendering, and one bad picture must not reject the whole batch.
  private static load = (url: string): Promise<string> =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = img.onabort = () => resolve(url);
      img.src = url;
    });

  public static preloadImages = (imageUrls: string[]): Promise<string[]> =>
    Promise.all((imageUrls ?? []).map((url) => ImageResource.load(url)));

  public static preloadImage = (url: string): Promise<string> => ImageResource.load(url);
}

export default ImageResource;
